module.exports = __webpack_public_path__ + "static/media/canaldemiitalic.0202644a.ttf";